
const currentYear = new Date().getFullYear();

// Generate years list from 2025 to current year
let years_list = [];
for (let year = 2025; year <= currentYear; year++) {
    years_list.push({ 
        id: year, 
        name: year.toString(), 
        key: year.toString() 
    });
}

    let months_list = [
        { name: "JANUARY", id: 1, key: "Jan" },
        { name: "FEBRUARY", id: 2, key: "Feb" },
        { name: "MARCH", id: 3, key: "Mar" },
        { name: "APRIL", id: 4, key: "Apr" },
        { name: "MAY", id: 5, key: "May" },
        { name: "JUNE", id: 6, key: "Jun" },
        { name: "JULY", id: 7, key: "Jul" },
        { name: "AUGUST", id: 8, key: "Aug" },
        { name: "SEPTEMBER", id: 9, key: "Sep" },
        { name: "OCTOBER", id: 10, key: "Oct" },
        { name: "NOVEMBER", id: 11, key: "Nov" },
        { name: "DECEMBER", id: 12, key: "Dec"}
      ]

      let categories_list = [
        { id: 1, name: "Collector", key: "Collector" },
        { id: 2, name: "Village", key: "Village" },
        { id: 3, name: "Zone", key: "Zone" },
        { id: 4, name: "Station", key: "Station" },
        { id: 5, name: "Line", key: "Line" },
        { id: 6, name: "Rate", key: "Rate" },
    ]

    let categories_with_serverside = [
        ...categories_list,
        { id: 7, name: "ServerSide", key: "ServerSide" },
    ]

    let categories_with_id = [
        ...categories_list,
        { id: 7, name: "ID", key: "ID" },
    ]

    let location_categories_list = [
        { id: 1, name: "Mulkiile", key: "Mulkiile" },
        { id: 2, name: "Kirayste", key: "Kirayste" },
    ]

    let gender_list = [
        {id: 1, name: "Male", key:"M"},
        {id: 2, name: "Female", key:"F"},
    ]

    let discount_options = [
        {id: 1, name: "Yes", key:"Yes"},
        {id: 2, name: "No", key:"No"},
    ]

    let priority_list = [
        {id: 1, name: "Normal", key:"Normal"},
        {id: 2, name: "Emergency", key:"Emergency"},
    ]

    let status_list = [
        {id: 1, name: "Active", key: "Active"},
        {id: 2, name: "Inactive", key: "Inactive"},
        {id: 3, name: "All", key: "All"},
    ]


    let todo_status_list = [
        {id: 1, name: "Active", key: "Active"},
        {id: 2, name: "Inactive", key: "Inactive"},
        {id: 3, name: "Pending", key: "Pending"},
    ]

    let hours_list = [
        {id: 0, name: "0:00", key: 0},
        {id: 1, name: "1:00", key: 1},
        {id: 2, name: "2:00", key: 2},
        {id: 3, name: "3:00", key: 3},
        {id: 4, name: "4:00", key: 4},
        {id: 5, name: "5:00", key: 5},
        {id: 6, name: "6:00", key: 6},
        {id: 7, name: "7:00", key: 7},
        {id: 8, name: "8:00", key: 8},
        {id: 9, name: "9:00", key: 9},
        {id: 10, name: "10:00", key: 10},
        {id: 11, name: "11:00", key: 11},
        {id: 12, name: "12:00", key: 12},
        {id: 13, name: "13:00", key: 13},
        {id: 14, name: "14:00", key: 14},
        {id: 15, name: "15:00", key: 15},
        {id: 16, name: "16:00", key: 16},
        {id: 17, name: "17:00", key: 17},
        {id: 18, name: "18:00", key: 18},
        {id: 19, name: "19:00", key: 19},
        {id: 20, name: "20:00", key: 20},
        {id: 21, name: "21:00", key: 21},
        {id: 22, name: "22:00", key: 22},
        {id: 23, name: "23:00", key: 23},
    ]

export {years_list, months_list, categories_list, categories_with_serverside, categories_with_id, location_categories_list, gender_list, status_list, todo_status_list, priority_list, hours_list, discount_options}